import {
  instance as axios,
  setJwtToken,
  setMultiPartHeader,
} from "../../config/axiosInstance";

// ---------------------Post-listing--------------------------
export const postListApi = async (data) => {
  const endPoint =
    `post/list` + "?" + new URLSearchParams({ ...data }).toString();

  return await axios.get(endPoint, setJwtToken());
};
// ------------------------Add Post------------------
export const addPostApi = async (data) => {
  const endPoint = `post/create`;
  return await axios.post(endPoint, data, setMultiPartHeader());
};
// ------------------------Edit Post------------------
export const editPostApi = async (data) => {
  const endPoint = `post/update`;
  return await axios.put(endPoint, data, setMultiPartHeader());
};
export const updatePostStatus = async (data) => {
  const endPoint = `post/change_status`;
  return await axios.put(endPoint, data, setJwtToken());
};
// ------------------------- remove Status------------
export const removePostApi = async (id) => {
  const endPoint = `post/delete/${id}`;
  return await axios.delete(endPoint, setJwtToken());
};
// ------------------------- post detail------------
export const postDetailApi = async (id) => {
  const endPoint = `post/detail/${id}`;
  return await axios.get(endPoint, setJwtToken());
};
//--------------------------- hastag list
export const postHastagListApi = async (data) => {
  const endPoint =
    `post/hashtag` + "?" + new URLSearchParams({ ...data }).toString();
  return await axios.get(endPoint, setJwtToken());
};

export const userTogglePostTrending = async (data) => {
  const endPoint = `post/trend`;
  return await axios.put(endPoint, data, setJwtToken());
};
